'use client'

import Link from 'next/link'

import { Icon } from '@/components/ui/icon'
import { CONTACT_PATHS } from '@/config/contact'
import { cn } from '@heroui/react'

interface QuoteButtonProps {
  /** 'prominent' = pill with text (public pages), 'subdued' = icon-only circle (app pages). */
  variant?: 'prominent' | 'subdued'
  className?: string
}

/**
 * The header CTA while online booking is switched off (BOOKING_ENABLED unset):
 * takes the slot ReservationButton owns when booking is on and sends the
 * visitor to the photo quote form instead.
 */
export function QuoteButton({ variant = 'subdued', className }: QuoteButtonProps) {
  if (variant === 'prominent') {
    return (
      <Link
        href={CONTACT_PATHS.quote}
        className={cn(
          'inline-flex h-10 items-center gap-1.5 rounded-full px-4 text-sm font-semibold leading-none no-underline transition-colors',
          'bg-[var(--btn-hot-bg)] text-[var(--btn-hot-fg)] hover:bg-[var(--btn-hot-bg-hover)]',
          className
        )}
        data-testid='header-quote-cta'
      >
        <Icon icon='quote' className='h-4 w-4' />
        Get a Quote
      </Link>
    )
  }
  return (
    <Link href={CONTACT_PATHS.quote} aria-label='Get a quote' className={className} data-testid='header-quote-cta'>
      <Icon icon='quote' className='h-5 w-5' />
    </Link>
  )
}
